import { DividerStyled } from './Divider.styles';
import { DividerProps } from './types';

/**
 * Divider component.
 */
export const Divider = (props: DividerProps) => <DividerStyled {...props} />;
